
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { AuthService } from '@lib/auth';
import { TranslatePipe } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'auth-login-password',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './auth-login-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLoginPasswordComponent {
  private readonly authService = inject(AuthService);

  protected readonly loading = signal<boolean>(false);
  protected readonly hidePassword = signal<boolean>(true);

  protected form = new FormGroup({
    phoneNumber: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  protected async login() {
    if (this.form.valid && this.form.value.phoneNumber && this.form.value.password) {
      this.loading.set(true);

      const success = await this.authService.loginWithPassword(this.form.value.phoneNumber, this.form.value.password);

      if (success) {
        this.authService.successAuthResult$.next(true);
      } else {
        // Show error - invalid credentials
        this.form.setErrors({ invalidCredentials: true });
        this.form.get('password')?.setErrors({ invalidCredentials: true });
      }

      this.loading.set(false);
    }
  }

  protected get phoneNumber() {
    return this.form.controls.phoneNumber as FormControl;
  }

  protected get password() {
    return this.form.controls.password as FormControl;
  }
}
